// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"5115":"6006ad6512fd85e4","6206":"b9099089ac4bb114","9216":"42e97adf0e5df2d3"}[chunkId] + ".css";
};